(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sm-pins-video"] && !Shopify.designMode) return;
  try {
    (function(){
  var panel=document.getElementById('sm-pins-video');if(!panel)return;
  var video=panel.querySelector('video');
  function pace(){video.playbackRate=video.currentTime>=17.8?6:1.25;}
  video.muted=true;video.defaultMuted=true;video.autoplay=true;video.playsInline=true;video.controls=false;
  video.addEventListener('timeupdate',pace);
  video.addEventListener('loadedmetadata',pace);
  pace();
  function tryPlay(){if(document.hidden||panel.hidden)return;var promise=video.play();if(promise&&promise.catch)promise.catch(function(){});}
  if('IntersectionObserver' in window){
    var playback=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){var play=video.play();if(play&&play.catch)play.catch(function(){});}
        else video.pause();
      });
    },{threshold:.08});
    playback.observe(video);
  }
  function place(){
    var pin=document.querySelector('.smgf');if(!pin||!pin.parentNode)return;
    if(pin.nextElementSibling!==panel)pin.insertAdjacentElement('afterend',panel);
    panel.hidden=false;tryPlay();
  }
  document.addEventListener('visibilitychange',function(){if(!document.hidden)tryPlay();});
  window.addEventListener('pageshow',tryPlay);document.addEventListener('scroll',tryPlay,{passive:true});
  place();document.addEventListener('DOMContentLoaded',place,{once:true});window.addEventListener('load',place,{once:true});document.addEventListener('shopify:section:load',place);
  var observer=new MutationObserver(place);observer.observe(document.documentElement,{childList:true,subtree:true});setTimeout(function(){observer.disconnect();place()},12000);
})();
  } catch(e) { console.error(e); }
})();

})();
